import React from "react";
import {Role} from "../interfaces";
import Login from "../pages/login";
import Shed from "pages/Shed/Shed";
import User from "pages/Users/User";
import Dog from "pages/Dog/Dog";
import Tenant from "../pages/Tenant/Tenant";
import Adoption from "pages/Adoption/Adoption";
import Treatment from "../pages/Treatment/Treatment";
import Box from "../pages/Box/Box";
import Municipality from "pages/Municipality/Municipality";
import UserAdmin from "../pages/Users/UserAdmin";
import Dead from "pages/Dead/Dead";
import Returned from "pages/Returned/Returned";
import Multimedia from "../pages/multimedia/Multimedia";
import WelcomePage from "../pages/WelcomePage";

interface route {
    path: string,
    component: React.ReactElement,
    isPrivate: boolean,
    requiredRoles?: Role[]
}

export const routes: route[] = [
    {
        path: "/",
        component: <WelcomePage/>,
        isPrivate: true,
        requiredRoles: ["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_USER"]
    },
    {
        path: "/login",
        component: <Login/>,
        isPrivate: false,

    },
    /*{
        path: "/Dashboard",
        component: <Dashboard/>,
        isPrivate: true,
        requiredRoles: ["ROLE_SUPER_ADMIN", "ROLE_ADMIN"]
    },*/

    {
        path: "/Adoption",
        component: <Adoption/>,
        isPrivate: true,
        requiredRoles: ["ROLE_ADMIN"]
    },

    {
        path: "/Dead",
        component: <Dead/>,
        isPrivate: true,
        requiredRoles: ["ROLE_ADMIN"]
    },

    {
        path: "/Returned",
        component: <Returned/>,
        isPrivate: true,
        requiredRoles: ["ROLE_ADMIN"]
    },


    {
        path: "/Utenti",
        component: <User/>,
        isPrivate: true,
        requiredRoles: ["ROLE_SUPER_ADMIN"]
    },

    {
        path: "/Utenti-admin",
        component: <UserAdmin/>,
        isPrivate: true,
        requiredRoles: ["ROLE_ADMIN"]
    },
    {
        path: "/capannoni",
        component: <Shed/>,
        isPrivate: true,
        requiredRoles: ["ROLE_ADMIN"]
    },
    {
        path: "/Box",
        component: <Box/>,
        isPrivate: true,
        requiredRoles: ["ROLE_ADMIN"]
    },
    {
        path: "/dog",
        component: <Dog/>,
        isPrivate: true,
        requiredRoles: ["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_USER"]
    },
    {
        path: "/multimedia",
        component: <Multimedia/>,
        isPrivate: true,
        requiredRoles: ["ROLE_SUPER_ADMIN"]
    },
    {
        path: "/Tenant",
        component: <Tenant/>,
        isPrivate: true,
        requiredRoles: ["ROLE_SUPER_ADMIN"]
    },
    {
        path: "/Treatment",
        component: <Treatment/>,
        isPrivate: true,
        requiredRoles: ["ROLE_ADMIN"]
    },
    {
        path: "/Municipality",
        component: <Municipality/>,
        isPrivate: true,
        requiredRoles: ["ROLE_SUPER_ADMIN"]
    },

]



